import { Statistic, Tooltip } from 'antd';
import React  from 'react';
import { CompanyUsage } from '../../../models/company-usage-interface';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/pro-regular-svg-icons';
import { Icon } from '@fortawesome/fontawesome-svg-core';

interface UsageStatisticListProps {
  item: CompanyUsage
}

export default function UsageStatistic({
  item,
}: UsageStatisticListProps) {

  return (
    <Statistic title={!!item.note ? <Tooltip title={item.note}>{item.title} <FontAwesomeIcon icon={faInfoCircle as Icon}/> </Tooltip> : item.title} value={item.value} prefix={item.isPercent ? "%" : null} />
  );
}
